import { useMutation } from "@tanstack/react-query";

import { api } from "@utils/api";

import { useQueryErrorHandling } from "@hooks/useQueryErrorHandling";


export const useResetPassword = () => {
  const handleErrors = useQueryErrorHandling();

  return useMutation({
    mutationFn: ({ password, token }: { password: string; token: string }) => {
      return api.post(
        "user/update/password/",
        { password },
        {
          params: { token },
        }
      );
    },

    onError: (res: any) => {
      console.error("[From Reset Password]", res);

      handleErrors(res, "mutation");
    },
  });
};
